module.exports = __webpack_public_path__ + "img/brand.db7a5a61.png";